import { observer, Switch } from '@legendapp/state/react';
import { Stack } from '@mantine/core';
import { uiState$ } from '../../state/ui.state';
import { AutoBetTab } from './auto-bet/AutoBetTab';
import styles from './Game.module.css';
import { GameAsideTabs } from './GameAsideTabs';
import { ManualBetTab } from './manual-bet/ManualBetTab';

export const GameAside = observer(() => {
  return (
    <Stack
      bg="dark.7"
      className={styles.sidebar}
      data-test-id="game-sidebar"
      gap={16}
      px={{
        base: 16,
        lg: 16,
      }}
      py={16}
    >
      <GameAsideTabs />
      <Switch value={uiState$.activeTab}>
        {{
          manual: () => <ManualBetTab />,
          auto: () => <AutoBetTab />,
        }}
      </Switch>
    </Stack>
  );
});
